export { default } from './VerticalSlide';
